import { Box, Button, InputLabel, Typography } from "@mui/material";
import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { professions } from "../asset/js/Professions";
import PostBidUploadImageUpdate from "./PostBidUploadImageUpdate";
import "./postbid-modern.css";

const animatedComponents = makeAnimated();

function PostBidGeneralInfoUpdate({ bidData }) {
  const officialProfessions = Array.from(professions);
  const initialSkills = bidData.skills ? bidData.skills.split(",").filter((skill) => officialProfessions.includes(skill)) : [];
  const [next, setNext] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [selectedOptions, setSelectedOptions] = React.useState(initialSkills.map((skill) => ({ value: skill, label: skill })));
  const options = officialProfessions.map((profession) => ({ value: profession, label: profession }));

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!selectedOptions.length) { setError(true); return; }
    setError(false);
    bidData.skills = selectedOptions.map((item) => item.value).join(",");
    setNext(true);
  };

  return (
    <Box className="bidit-postbid-step" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      {!next ? (
        <Box component="form" className="bidit-form-card" onSubmit={handleSubmit}>
          <Box className="bidit-form-intro">
            <Box className="bidit-form-intro-badge"><span className="bidit-form-intro-spark">✦</span>עריכת מקצוע</Box>
            <Typography variant="h6" className="bidit-form-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>מי בעל המקצוע המתאים?</Typography>
            <Typography className="bidit-form-subtitle" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>ניתן לבחור רק מקצועות פעילים במערכת</Typography>
          </Box>
          <InputLabel sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mb: 1 }}>מקצועות</InputLabel>
          <Select
            components={animatedComponents}
            isMulti
            name="professions"
            value={selectedOptions}
            options={options}
            onChange={(items) => setSelectedOptions(items || [])}
            className="select bidit-profession-select"
            classNamePrefix="select"
            isClearable
            isSearchable
            closeMenuOnSelect={false}
            placeholder="חיפוש מקצוע מתוך הרשימה"
            noOptionsMessage={() => "המקצוע לא קיים כרגע ברשימה"}
          />
          {error && <Box className="bidit-inline-error">יש לבחור מקצוע אחד לפחות</Box>}
          <Button type="submit" fullWidth variant="contained" className="bidit-primary-button" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 3, mb: 2 }}>ממשיכים למדיה</Button>
        </Box>
      ) : <PostBidUploadImageUpdate bidData={bidData} />}
    </Box>
  );
}
export default PostBidGeneralInfoUpdate;
